<template>
  <router-view ></router-view>
</template>

<script>
  export default {
    name: "user"
  }
</script>

<style scoped>

</style>
